import { ref } from 'vue'
import { defineStore } from 'pinia'

export interface PrompterMessage {
  header : String
  body : String
}

export const usePromptStore = defineStore('prompt', () => {
  const message = ref<PrompterMessage | null>(null)
  function promptUser(msg : PrompterMessage) {
    message.value = msg
  }

  function close() {
    message.value = null
  }

  return { message, promptUser, close }
})

/*
export const usePromptStore = defineStore({
    id: 'prompt',
    state: () => ({
        prompt: null
    }),
    actions: {
        prompt(message) {
            this.prompt = message; //{ message, type: 'alert-success' };
        },
        error(message) {
            this.alert = { message, type: 'alert-danger' };
        },
        close() {
            this.prompt = null;
        }
    }
});*/
